import React from 'react';
import {connect} from "react-redux";
import {NavLink} from "react-router-dom";
import Tooltip from '@material-ui/core/Tooltip';
import * as actionCreators from "../../actions/actionCreators"
import Archives from "../../component/audit/archives.js";
import moment from 'moment';

import IconButton from '@material-ui/core/IconButton';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import 'moment/locale/fr';

moment.locale('fr');

const options = {
  filterType: 'checkbox',
  viewColumns: true,
  selectableRows: false,
  responsive: 'scroll',
  rowHover: false,
  textLabels: {
    body: {
      noMatch: "Désolé, aucun résultat n'a été trouvé",
      toolTip: "Sort",
    },
    pagination: {
      next: "Suivant",
      previous: "Précédent",
      rowsPerPage: "Lignes par page:",
      displayRows: "de",
    },
    toolbar: {
      search: "Recherche",
      downloadCsv: "Téléchrager CSV",
      print: "Imprimer",
      viewColumns: "Visibilité des colonnes",
      filterTable: "Filtres",
    },
    filter: {
      all: "Tous",
      title: "FILTRES",
      reset: "ANNULER",
    },
    viewColumns: {
      title: "Visibilité des colonnes",
      titleAria: "Affiche/Cacher des colonnes",
    },
    selectedRows: {
      text: "ligne(s) sélectionnée(s)",
      delete: "Supprimer",
      deleteAria: "Supprimer les lignes sélectionnée(s)",
    },
  },
  customSort: (data, colIndex, order) => {
        if(colIndex === 3){

            return order === "asc" ? data.sort((a, b) => {
                if (a.data[colIndex] === null || a.data[colIndex] === "") {
                    return 1;
                }
                else if (b.data[colIndex] === null || b.data[colIndex] === "") {
                    return -1;
                }
                else if (a.data[colIndex]  === b.data[colIndex] ) {
                    return 0;
                }
                var timestamp_a = moment(a.data[colIndex], 'DD/MM/YYYY à HH:mm').toDate();
                var timestamp_b = moment(b.data[colIndex], 'DD/MM/YYYY à HH:mm').toDate();
                return (timestamp_a < timestamp_b) - (timestamp_a > timestamp_b);
            }) : data.sort((a, b) => {
                if (a.data[colIndex] === null || a.data[colIndex] === "") {
                    return 1;
                }
                else if (b.data[colIndex] === null || b.data[colIndex] === "") {
                    return -1;
                }
                else if (a.data[colIndex]  === b.data[colIndex] ) {
                    return 0;
                }
                var timestamp_a = moment(a.data[colIndex], 'DD/MM/YYYY à HH:mm').toDate();
                var timestamp_b = moment(b.data[colIndex], 'DD/MM/YYYY à HH:mm').toDate();
                return (timestamp_a > timestamp_b) - (timestamp_a < timestamp_b);
            });
        }else{
            return order === "asc" ? data.sort((a, b) => (a.data[colIndex] < b.data[colIndex]) - (a.data[colIndex] > b.data[colIndex])) : data.sort((a, b) => (a.data[colIndex] > b.data[colIndex]) - (a.data[colIndex] < b.data[colIndex]));
        }

  }
};

class Archivescon extends React.Component{
  constructor(props) {
    super(props);

    this.handleAuditRemove = this.handleAuditRemove.bind(this);
    this.addDataToDatatable = this.addDataToDatatable.bind(this);

    this.state = {
      data: [],
    loading: true,
      columns: [
        {name: "Action(s)",options: {filter: false,sort: false,customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{display: 'flex'}}>
              <Tooltip title="Ouvrir">
                  <span style={{width: 48, height: 48}}>
                    <NavLink style={{textDecoration: 'none', width: 48, height: 48, margin: 11, display: 'block', color: '#3f51b5'}} to={"/audits/" + value}><OpenInBrowserIcon /></NavLink>
                  </span>
              </Tooltip>
              <Tooltip title="Supprimer">
                  <span style={{width: 48, height: 48}}>
                    <IconButton aria-label="Delete" onClick={() => this.props.displayConfirmation("Suppression", "Êtes-vous sûr de vouloir supprimer cet audit ?", () => this.handleAuditRemove(value))}>
                      <DeleteOutlineIcon />
                    </IconButton>
                  </span>
              </Tooltip>
            </div>
          );
        } }},
        {name: "Entreprise",options: {filter: false }},
        {name: "Réf. Entreprise",options: {filter: false }},
        {name: "Date",options: {filter: false, sort: true, sortDirection: 'desc'}},
        {name: "Adresse",options: {filter: false}},
        {name: "Status",options: {filter: true }},
        {name: "Facturé",options: {filter: false }},
      ]
    }
  }

  handleAuditRemove(id) {
    this.props.removeAuditAction(id).then(res=>{
      /* supprime l'audit du tableau */
      this.setState(function(prevState){
        return { data : prevState.data.filter(function(val, i) {
          return val[0] !== id;
        })};
      })
    })
    this.props.closeConfirmation()
  }

  translateStatus(status){
    switch(status){
        case "waiting":
            return "En attente";
        case "appointment":
            return "Rendez-vous validé"
        case "appointment_notified":
            return "Rendez-vous non validé"
        case "valid":
            return "Validé"
        case "issue":
            return "Écart"
        case "reject":
            return "Rejeté"
        default:
            return status;
    }
  }

  componentWillMount() {
      /* import les audits du state */
      this.addDataToDatatable()
  }

    componentDidMount() {
        /* import les audits */
        this.props.getArchivesAction().then(res => {
            this.addDataToDatatable(true)
        }).catch(err => {
            this.props.displaySnackbar("error", "Erreur de chargement");
            this.setState({loading: false})
        })
    }

  addDataToDatatable(loaded){
      let data = []
      /* Convertie les objects en array */
      for (var i in this.props.archives) {
          let values = []
          let obj = this.props.archives[i];
          obj.hasOwnProperty("id") && obj.id ? values.push(obj.id.toString()) : values.push("")
          obj.hasOwnProperty("company") && values.push(obj.company.name)
          obj.hasOwnProperty("company") && values.push(parseInt(obj.company.reference, 10))
          obj.hasOwnProperty("date") && obj.date ? values.push(moment(obj.date).format("DD/MM/YYYY à HH:mm")) : values.push("")
          obj.hasOwnProperty("address") && obj.address ? values.push(obj.address.toString()) : values.push("")
          obj.hasOwnProperty("status") && obj.status ? values.push( !obj.date && obj.date_limit && (moment(obj.date_limit).isSameOrBefore(moment().add(3, 'months')) ) ? "Retard" : this.translateStatus(obj.status.toString()) ) : values.push("")
          obj.hasOwnProperty("invoices") && values.push(obj.invoices.length > 0 ? "Oui" : "Non")

          data.push(values)
      }
      if(loaded){
          this.setState({
              data: data,
              loading: false,
          })
      }else{
          this.setState({
              data: data,
          })
      }
  }

  render(){
    return <Archives columns={this.state.columns} data={this.state.data} options={options} loading={this.state.loading}></Archives>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Archivescon);



// WEBPACK FOOTER //
// ./src/container/audit/archives-container.js